import { OptionGroup } from "../../components/register/StyledDropdown";

// Data for Grade Dropdowns
export const aLevelGrades = ['A*', 'A', 'B', 'C', 'D', 'E'];
export const gcseGrades = ['9', '8', '7', '6', '5', '4', '3', '2', '1'];
export const apGrades = ['5', '4', '3', '2', '1'];
export const ibGrades = ['7', '6', '5', '4', '3', '2', '1', 'A', 'B', 'C', 'D', 'E'];
export const scottishHighersGrades = ['A', 'B', 'C', 'D'];
export const cambridgePreUGrades = ['D1', 'D2', 'D3', 'M1', 'M2', 'M3', 'P1', 'P2', 'P3'];
export const irishLeavingCertGrades = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'H7', 'H8', 'O1', 'O2', 'O3', 'O4', 'O5', 'O6', 'O7', 'O8'];
export const hkdseGrades = ['5**', '5*', '5', '4', '3', '2', '1'];
export const indianSchoolCertificateGrades = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
export const singaporeGceALevelGrades = ['A', 'B', 'C', 'D', 'E', 'S', 'U'];

export const ibSubjectOptions: OptionGroup[] = [
    {
    label: 'IB Core',
    options: [
      { value: 'Theory of Knowledge', label: 'Theory of Knowledge' },
      { value: 'Extended Essay', label: 'Extended Essay' },
    ],
    },
    {

      label: 'Group 1: Studies in Language and Literature',
      options: [
        { value: 'English A: Literature HL', label: 'English A: Literature (HL)' },
        { value: 'English A: Literature SL', label: 'English A: Literature (SL)' },
        { value: 'English A: Language and Literature HL', label: 'English A: Language and Literature (HL)' },
        { value: 'English A: Language and Literature SL', label: 'English A: Language and Literature (SL)' },
        { value: 'French A: Literature HL', label: 'French A: Literature (HL)' },
        { value: 'French A: Literature SL', label: 'French A: Literature (SL)' },
        { value: 'French A: Language and Literature HL', label: 'French A: Language and Literature (HL)' },
        { value: 'French A: Language and Literature SL', label: 'French A: Language and Literature (SL)' },
        { value: 'Spanish A: Literature HL', label: 'Spanish A: Literature (HL)' },
        { value: 'Spanish A: Literature SL', label: 'Spanish A: Literature (SL)' },
        { value: 'Spanish A: Language and Literature HL', label: 'Spanish A: Language and Literature (HL)' },
        { value: 'Spanish A: Language and Literature SL', label: 'Spanish A: Language and Literature (SL)' },
        { value: 'Chinese A: Literature HL', label: 'Chinese A: Literature (HL)' },
        { value: 'Chinese A: Literature SL', label: 'Chinese A: Literature (SL)' },
        { value: 'Chinese A: Language and Literature HL', label: 'Chinese A: Language and Literature (HL)' },
        { value: 'Chinese A: Language and Literature SL', label: 'Chinese A: Language and Literature (SL)' },
        { value: 'German A: Literature HL', label: 'German A: Literature (HL)' },
        { value: 'German A: Literature SL', label: 'German A: Literature (SL)' },
        { value: 'Japanese A: Literature HL', label: 'Japanese A: Literature (HL)' },
        { value: 'Japanese A: Literature SL', label: 'Japanese A: Literature (SL)' },
        { value: 'Russian A: Literature HL', label: 'Russian A: Literature (HL)' },
        { value: 'Russian A: Literature SL', label: 'Russian A: Literature (SL)' },
        { value: 'Literature and Performance SL', label: 'Literature and Performance (SL)' },
        { value: 'Other Language A: Literature SL', label: 'Other Language A: Literature (Self-Taught SL)' },
      ],
    },
    {
      label: 'Group 2: Language Acquisition',
      options: [
        { value: 'English B HL', label: 'English B (HL)' },
        { value: 'English B SL', label: 'English B (SL)' },
        { value: 'French B HL', label: 'French B (HL)' },
        { value: 'French B SL', label: 'French B (SL)' },
        { value: 'French ab initio SL', label: 'French ab initio (SL)' },
        { value: 'Spanish B HL', label: 'Spanish B (HL)' },
        { value: 'Spanish B SL', label: 'Spanish B (SL)' },
        { value: 'Spanish ab initio SL', label: 'Spanish ab initio (SL)' },
        { value: 'German B HL', label: 'German B (HL)' },
        { value: 'German B SL', label: 'German B (SL)' },
        { value: 'German ab initio SL', label: 'German ab initio (SL)' },
        { value: 'Mandarin B HL', label: 'Mandarin B (HL)' },
        { value: 'Mandarin B SL', label: 'Mandarin B (SL)' },
        { value: 'Mandarin ab initio SL', label: 'Mandarin ab initio (SL)' },
        { value: 'Latin HL', label: 'Latin (HL)' },
        { value: 'Latin SL', label: 'Latin (SL)' },
        { value: 'Classical Greek HL', label: 'Classical Greek (HL)' },
        { value: 'Classical Greek SL', label: 'Classical Greek (SL)' },
        { value: 'Arabic B HL', label: 'Arabic B (HL)' },
        { value: 'Arabic B SL', label: 'Arabic B (SL)' },
        { value: 'Arabic ab initio SL', label: 'Arabic ab initio (SL)' },
        { value: 'Italian B HL', label: 'Italian B (HL)' },
        { value: 'Italian B SL', label: 'Italian B (SL)' },
        { value: 'Italian ab initio SL', label: 'Italian ab initio (SL)' },
        { value: 'Japanese B HL', label: 'Japanese B (HL)' },
        { value: 'Japanese B SL', label: 'Japanese B (SL)' },
        { value: 'Japanese ab initio SL', label: 'Japanese ab initio (SL)' },
        { value: 'Russian B HL', label: 'Russian B (HL)' },
        { value: 'Russian B SL', label: 'Russian B (SL)' },
      ],
    },
    {
      label: 'Group 3: Individuals and Societies',
      options: [
        { value: 'Business Management HL', label: 'Business Management (HL)' },
        { value: 'Business Management SL', label: 'Business Management (SL)' },
        { value: 'Economics HL', label: 'Economics (HL)' },
        { value: 'Economics SL', label: 'Economics (SL)' },
        { value: 'Geography HL', label: 'Geography (HL)' },
        { value: 'Geography SL', label: 'Geography (SL)' },
        { value: 'Global Politics HL', label: 'Global Politics (HL)' },
        { value: 'Global Politics SL', label: 'Global Politics (SL)' },
        { value: 'History HL', label: 'History (HL)' },
        { value: 'History SL', label: 'History (SL)' },
        { value: 'ITGS HL', label: 'Information Technology in a Global Society (HL)' },
        { value: 'ITGS SL', label: 'Information Technology in a Global Society (SL)' },
        { value: 'Philosophy HL', label: 'Philosophy (HL)' },
        { value: 'Philosophy SL', label: 'Philosophy (SL)' },
        { value: 'Psychology HL', label: 'Psychology (HL)' },
        { value: 'Psychology SL', label: 'Psychology (SL)' },
        { value: 'Social and Cultural Anthropology HL', label: 'Social and Cultural Anthropology (HL)' },
        { value: 'Social and Cultural Anthropology SL', label: 'Social and Cultural Anthropology (SL)' },
        { value: 'World Religions SL', label: 'World Religions (SL)' },
        { value: 'ESS SL', label: 'Environmental Systems and Societies (SL)' },
      ],
    },
    {
      label: 'Group 4: Sciences',
      options: [
        { value: 'Biology HL', label: 'Biology (HL)' },
        { value: 'Biology SL', label: 'Biology (SL)' },
        { value: 'Chemistry HL', label: 'Chemistry (HL)' },
        { value: 'Chemistry SL', label: 'Chemistry (SL)' },
        { value: 'Physics HL', label: 'Physics (HL)' },
        { value: 'Physics SL', label: 'Physics (SL)' },
        { value: 'Computer Science HL', label: 'Computer Science (HL)' },
        { value: 'Computer Science SL', label: 'Computer Science (SL)' },
        { value: 'Design Technology HL', label: 'Design Technology (HL)' },
        { value: 'Design Technology SL', label: 'Design Technology (SL)' },
        { value: 'Sports, Exercise and Health Science HL', label: 'Sports, Exercise and Health Science (HL)' },
        { value: 'Sports, Exercise and Health Science SL', label: 'Sports, Exercise and Health Science (SL)' },
        { value: 'ESS SL', label: 'Environmental Systems and Societies (SL)' },
      ],
    },
    {
      label: 'Group 5: Mathematics',
      options: [
        { value: 'Mathematics: Analysis and Approaches HL', label: 'Mathematics: Analysis and Approaches (HL)' },
        { value: 'Mathematics: Analysis and Approaches SL', label: 'Mathematics: Analysis and Approaches (SL)' },
        { value: 'Mathematics: Applications and Interpretation HL', label: 'Mathematics: Applications and Interpretation (HL)' },
        { value: 'Mathematics: Applications and Interpretation SL', label: 'Mathematics: Applications and Interpretation (SL)' },
        // Old Curriculum
        { value: 'Mathematical Studies SL', label: 'Mathematical Studies SL' },
        { value: 'Mathematics SL', label: 'Mathematics SL' },
        { value: 'Mathematics HL', label: 'Mathematics HL' },
        { value: 'Further Mathematics HL', label: 'Further Mathematics HL' },
      ],
    },
    {
      label: 'Group 6: The Arts',
      options: [
        { value: 'Dance HL', label: 'Dance (HL)' },
        { value: 'Dance SL', label: 'Dance (SL)' },
        { value: 'Film HL', label: 'Film (HL)' },
        { value: 'Film SL', label: 'Film (SL)' },
        { value: 'Music HL', label: 'Music (HL)' },
        { value: 'Music SL', label: 'Music (SL)' },
        { value: 'Theatre HL', label: 'Theatre (HL)' },
        { value: 'Theatre SL', label: 'Theatre (SL)' },
        { value: 'Visual Arts HL', label: 'Visual Arts (HL)' },
        { value: 'Visual Arts SL', label: 'Visual Arts (SL)' },
      ],
    },
  ];

export const irishLeavingCertSubjectOptions: OptionGroup[] = [
  {
    label: 'Core & Languages',
    options: [
        { value: 'English', label: 'English' },
        { value: 'Irish', label: 'Irish' },
        { value: 'Mathematics', label: 'Mathematics' },
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Latin', label: 'Latin' },
        { value: 'Classical Greek', label: 'Classical Greek' },
    ],
  },
  {
    label: 'Sciences & Technology',
    options: [
        { value: 'Agricultural Science', label: 'Agricultural Science' },
        { value: 'Biology', label: 'Biology' },
        { value: 'Chemistry', label: 'Chemistry' },
        { value: 'Physics', label: 'Physics' },
        { value: 'Physics and Chemistry', label: 'Physics and Chemistry (Combined)' },
        { value: 'Computer Science', label: 'Computer Science' },
        { value: 'Design and Communication Graphics', label: 'Design and Communication Graphics' },
        { value: 'Engineering', label: 'Engineering' },
        { value: 'Construction Studies', label: 'Construction Studies' },
    ],
  },
  {
    label: 'Business & Social Studies',
    options: [
        { value: 'Accounting', label: 'Accounting' },
        { value: 'Business', label: 'Business' },
        { value: 'Economics', label: 'Economics' },
        { value: 'Geography', label: 'Geography' },
        { value: 'History', label: 'History' },
        { value: 'Politics and Society', label: 'Politics and Society' },
        { value: 'Religious Education', label: 'Religious Education' },
        { value: 'Classical Studies', label: 'Classical Studies' },
    ],
  },
  {
    label: 'Arts & Music',
    options: [
        { value: 'Art', label: 'Art' },
        { value: 'Music', label: 'Music' },
        { value: 'Home Economics', label: 'Home Economics' },
    ],
  },
];

export const apSubjectOptions: OptionGroup[] = [
    {
      label: 'Arts',
      options: [
        { value: 'AP 2-D Art and Design', label: 'AP 2-D Art and Design' },
        { value: 'AP 3-D Art and Design', label: 'AP 3-D Art and Design' },
        { value: 'AP Drawing', label: 'AP Drawing' },
        { value: 'AP Art History', label: 'AP Art History' },
        { value: 'AP Music Theory', label: 'AP Music Theory' },
      ],
    },
    {
      label: 'English',
      options: [
        { value: 'AP English Language and Composition', label: 'AP English Language and Composition' },
        { value: 'AP English Literature and Composition', label: 'AP English Literature and Composition' },
      ],
    },
    {
      label: 'History & Social Sciences',
      options: [
        { value: 'AP Comparative Government and Politics', label: 'AP Comparative Government and Politics' },
        { value: 'AP European History', label: 'AP European History' },
        { value: 'AP Human Geography', label: 'AP Human Geography' },
        { value: 'AP Macroeconomics', label: 'AP Macroeconomics' },
        { value: 'AP Microeconomics', label: 'AP Microeconomics' },
        { value: 'AP Psychology', label: 'AP Psychology' },
        { value: 'AP United States Government and Politics', label: 'AP United States Government and Politics' },
        { value: 'AP United States History', label: 'AP United States History' },
        { value: 'AP World History: Modern', label: 'AP World History: Modern' },
      ],
    },
    {
      label: 'Math & Computer Science',
      options: [
        { value: 'AP Precalculus', label: 'AP Precalculus' },
        { value: 'AP Calculus AB', label: 'AP Calculus AB' },
        { value: 'AP Calculus BC', label: 'AP Calculus BC' },
        { value: 'AP Statistics', label: 'AP Statistics' },
        { value: 'AP Computer Science A', label: 'AP Computer Science A' },
        { value: 'AP Computer Science Principles', label: 'AP Computer Science Principles' },
      ],
    },
      {
      label: 'Sciences',
      options: [
        { value: 'AP Biology', label: 'AP Biology' },
        { value: 'AP Chemistry', label: 'AP Chemistry' },
        { value: 'AP Environmental Science', label: 'AP Environmental Science' },
        { value: 'AP Physics 1: Algebra-Based', label: 'AP Physics 1: Algebra-Based' },
        { value: 'AP Physics 2: Algebra-Based', label: 'AP Physics 2: Algebra-Based' },
        { value: 'AP Physics C: Electricity and Magnetism', label: 'AP Physics C: Electricity and Magnetism' },
        { value: 'AP Physics C: Mechanics', label: 'AP Physics C: Mechanics' },
      ],
    },
    {
      label: 'World Languages & Cultures',
      options: [
        { value: 'AP Chinese Language and Culture', label: 'AP Chinese Language and Culture' },
        { value: 'AP French Language and Culture', label: 'AP French Language and Culture' },
        { value: 'AP German Language and Culture', label: 'AP German Language and Culture' },
        { value: 'AP Italian Language and Culture', label: 'AP Italian Language and Culture' },
        { value: 'AP Japanese Language and Culture', label: 'AP Japanese Language and Culture' },
        { value: 'AP Latin', label: 'AP Latin' },
        { value: 'AP Spanish Language and Culture', label: 'AP Spanish Language and Culture' },
        { value: 'AP Spanish Literature and Culture', label: 'AP Spanish Literature and Culture' },
      ],
    },
  ];

export const cambridgePreUSubjectOptions: OptionGroup[] = [
    {
      label: 'Humanities & Social Sciences',
      options: [
        { value: 'Classical Heritage', label: 'Classical Heritage' },
        { value: 'Geography', label: 'Geography' },
        { value: 'History', label: 'History' },
        { value: 'Philosophy & Theology', label: 'Philosophy & Theology' },
        { value: 'Psychology', label: 'Psychology' },
      ],
    },
    {
      label: 'Languages',
      options: [
        { value: 'English Literature', label: 'English Literature' },
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Mandarin Chinese', label: 'Mandarin Chinese' },
        { value: 'Russian', label: 'Russian' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Classical Greek', label: 'Classical Greek' },
        { value: 'Latin', label: 'Latin' },
      ],
    },
    {
      label: 'Mathematics & Sciences',
      options: [
        { value: 'Biology', label: 'Biology' },
        { value: 'Chemistry', label: 'Chemistry' },
        { value: 'Mathematics', label: 'Mathematics' },
        { value: 'Further Mathematics', label: 'Further Mathematics' },
        { value: 'Physics', label: 'Physics' },
      ],
    },
    {
      label: 'Arts & Business',
      options: [
        { value: 'Art and Design', label: 'Art and Design' },
        { value: 'Business and Management', label: 'Business and Management' },
        { value: 'Economics', label: 'Economics' },
        { value: 'Music', label: 'Music' },
      ],
    },
  ];
  

export const scottishHighersSubjectOptions: OptionGroup[] = [
    {
      label: 'Sciences',
      options: [
        { value: 'Biology', label: 'Biology' },
        { value: 'Human Biology', label: 'Human Biology' },
        { value: 'Chemistry', label: 'Chemistry' },
        { value: 'Physics', label: 'Physics' },
        { value: 'Environmental Science', label: 'Environmental Science' },
      ],
    },
    {
      label: 'Mathematics & Computing',
      options: [
        { value: 'Mathematics', label: 'Mathematics' },
        { value: 'Applications of Mathematics', label: 'Applications of Mathematics' },
        { value: 'Computer Science', label: 'Computer Science' },
      ],
    },
    {
      label: 'Social Studies & Humanities',
      options: [
        { value: 'History', label: 'History' },
        { value: 'Modern Studies', label: 'Modern Studies' },
        { value: 'Geography', label: 'Geography' },
        { value: 'Sociology', label: 'Sociology' },
        { value: 'Psychology', label: 'Psychology' },
        { value: 'Philosophy', label: 'Philosophy' },
        { value: 'Religious, Moral and Philosophical Studies', label: 'Religious, Moral and Philosophical Studies' },
        { value: 'Classical Studies', label: 'Classical Studies' },
      ],
    },
    {
      label: 'Business & Enterprise',
      options: [
        { value: 'Business Management', label: 'Business Management' },
        { value: 'Economics', label: 'Economics' },
        { value: 'Accounting', label: 'Accounting' },
      ],
    },
    {
      label: 'Languages',
      options: [
        { value: 'English', label: 'English' },
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Mandarin (Simplified/Traditional)', label: 'Mandarin (Simplified/Traditional)' },
        { value: 'Gaelic (Learners)', label: 'Gaelic (Learners)' },
        { value: 'Urdu', label: 'Urdu' },
        { value: 'Latin', label: 'Latin' },
      ],
    },
    {
      label: 'Expressive Arts & Design',
      options: [
        { value: 'Art and Design', label: 'Art and Design' },
        { value: 'Music', label: 'Music' },
        { value: 'Drama', label: 'Drama' },
        { value: 'Photography', label: 'Photography' },
        { value: 'Design and Manufacture', label: 'Design and Manufacture' },
        { value: 'Graphic Communication', label: 'Graphic Communication' },
      ],
    },
  ];

export const gcseSubjectOptions: OptionGroup[] = [
    {
      label: 'Core Subjects',
      options: [
        { value: 'Mathematics', label: 'Mathematics' },
        { value: 'English Language', label: 'English Language' },
        { value: 'English Literature', label: 'English Literature' },
      ],
    },
    {
      label: 'Sciences',
      options: [
        { value: 'Combined Science', label: 'Combined Science' },
        { value: 'Biology', label: 'Biology (Single Science)' },
        { value: 'Chemistry', label: 'Chemistry (Single Science)' },
        { value: 'Physics', label: 'Physics (Single Science)' },
        { value: 'Computer Science', label: 'Computer Science' },
      ],
    },
    {
      label: 'Humanities',
      options: [
        { value: 'History', label: 'History' },
        { value: 'Geography', label: 'Geography' },
        { value: 'Religious Studies', label: 'Religious Studies' },
        { value: 'Citizenship Studies', label: 'Citizenship Studies' },
        { value: 'Classical Civilisation', label: 'Classical Civilisation' },
        { value: 'Sociology', label: 'Sociology' },
        { value: 'Psychology', label: 'Psychology' },
      ],
    },
    {
      label: 'Modern & Ancient Languages',
      options: [
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Mandarin', label: 'Mandarin' },
        { value: 'Arabic', label: 'Arabic' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Russian', label: 'Russian' },
        { value: 'Urdu', label: 'Urdu' },
        { value: 'Latin', label: 'Latin' },
        { value: 'Classical Greek', label: 'Classical Greek' },
      ],
    },
    {
      label: 'Arts & Design',
      options: [
        { value: 'Art and Design', label: 'Art and Design' },
        { value: 'Music', label: 'Music' },
        { value: 'Drama', label: 'Drama' },
        { value: 'Dance', label: 'Dance' },
        { value: 'Photography', label: 'Photography' },
        { value: 'Textiles', label: 'Textiles' },
      ],
    },
     {
      label: 'Business & Technical',
      options: [
        { value: 'Business Studies', label: 'Business Studies' },
        { value: 'Economics', label: 'Economics' },
        { value: 'Design and Technology (D&T)', label: 'Design and Technology (D&T)' },
        { value: 'Food Preparation and Nutrition', label: 'Food Preparation and Nutrition' },
        { value: 'Physical Education (PE)', label: 'Physical Education (PE)' },
        { value: 'Media Studies', label: 'Media Studies' },
      ],
    },
  ];
  
  export const aLevelSubjectOptions: OptionGroup[] = [
    {
      label: 'STEM Subjects',
      options: [
        { value: 'Mathematics', label: 'Mathematics' },
        { value: 'Further Mathematics', label: 'Further Mathematics' },
        { value: 'Biology', label: 'Biology' },
        { value: 'Chemistry', label: 'Chemistry' },
        { value: 'Physics', label: 'Physics' },
        { value: 'Computer Science', label: 'Computer Science' },
        { value: 'Psychology', label: 'Psychology' },
      ],
    },
    {
      label: 'Humanities & Social Sciences',
      options: [
        { value: 'History', label: 'History' },
        { value: 'Geography', label: 'Geography' },
        { value: 'Politics', label: 'Politics' },
        { value: 'Sociology', label: 'Sociology' },
        { value: 'Philosophy', label: 'Philosophy' },
        { value: 'Religious Studies', label: 'Religious Studies' },
        { value: 'Classical Civilisation', label: 'Classical Civilisation' },
        { value: 'Law', label: 'Law' },
      ],
    },
    {
      label: 'Economics & Business',
      options: [
        { value: 'Economics', label: 'Economics' },
        { value: 'Business', label: 'Business' },
        { value: 'Accounting', label: 'Accounting' },
      ],
    },
    {
      label: 'Languages',
      options: [
        { value: 'English Literature', label: 'English Literature' },
        { value: 'English Language', label: 'English Language' },
        { value: 'English Language and Literature', label: 'English Language and Literature' },
        { value: 'French', label: 'French' },
        { value: 'German', label: 'German' },
        { value: 'Spanish', label: 'Spanish' },
        { value: 'Mandarin', label: 'Mandarin' },
        { value: 'Italian', label: 'Italian' },
        { value: 'Russian', label: 'Russian' },
        { value: 'Latin', label: 'Latin' },
        { value: 'Classical Greek', label: 'Classical Greek' },
      ],
    },
    {
      label: 'Creative Arts & Design',
      options: [
        { value: 'Art and Design', label: 'Art and Design' },
        { value: 'Drama and Theatre', label: 'Drama and Theatre' },
        { value: 'Music', label: 'Music' },
        { value: 'Music Technology', label: 'Music Technology' },
        { value: 'Photography', label: 'Photography' },
        { value: 'Media Studies', label: 'Media Studies' },
        { value: 'Film Studies', label: 'Film Studies' },
        { value: 'Design and Technology (D&T)', label: 'Design and Technology (D&T)' },
      ],
    },
  ];



  export const qualificationOptions = [
    {
      label: 'School Qualifications (UK)',
      options: [
        { value: 'A-Level', label: 'A-Level', format: 'subject-grade' },
        { value: 'GCSE', label: 'GCSE / IGCSE', format: 'subject-grade' },
        { value: 'Scottish Highers', label: 'Scottish Highers / Advanced Highers', format: 'subject-grade' },
      ],
    },
    {
      label: 'School Qualifications (International)',
      options: [
        { value: 'IB Diploma', label: 'International Baccalaureate (IB) Diploma', format: 'subject-grade' },
        { value: 'AP', label: 'AP (Advanced Placement)', format: 'subject-grade' },
        { value: 'Cambridge Pre-U', label: 'Cambridge Pre-U', format: 'subject-grade' },
        { value: 'French Baccalaureate', label: 'French Baccalauréat', format: 'single-score', min: 0, max: 20 },
        { value: 'German Abitur', label: 'German Abitur', format: 'single-score', min: 1, max: 4 },
        { value: 'Irish Leaving Certificate', label: 'Irish Leaving Certificate', format: 'subject-grade' },
        { value: 'HKDSE', label: 'Hong Kong Diploma (HKDSE)', format: 'subject-grade' },
        { value: 'Indian School Certificate', label: 'Indian School Certificate (ISC)', format: 'subject-grade' },
        { value: 'Singapore GCE A-Level', label: 'Singapore-Cambridge GCE A-Level', format: 'subject-grade' },
        { value: 'ATAR', label: 'Australian Tertiary Admission Rank (ATAR)', format: 'single-score', min: 0, max: 99.95 },
        { value: 'Canadian High School Diploma', label: 'Canadian High School Diploma', format: 'subject-grade' },
      ],
    },
    {
        label: 'Admissions & Standardized Tests',
        options: [
          { value: 'BMAT', label: 'BMAT (BioMedical Admissions Test)', format: 'test-score', min: 1, max: 9 },
          { value: 'UCAT', label: 'UCAT (University Clinical Aptitude Test)', format: 'test-score', min: 1200, max: 3600 },
          { value: 'LNAT', label: 'LNAT (National Admissions Test for Law)', format: 'test-score', min: 0, max: 42 },
          { value: 'MAT', label: 'MAT (Mathematics Admissions Test)', format: 'test-score', min: 0, max: 100 },
          { value: 'STEP', label: 'STEP (Sixth Term Examination Paper)', format: 'test-score' }, // Grade-based, so no min/max
          { value: 'PAT', label: 'PAT (Physics Aptitude Test)', format: 'test-score', min: 0, max: 100 },
          { value: 'TSA', label: 'TSA (Thinking Skills Assessment)', format: 'test-score', min: 0, max: 100 },
          { value: 'TMUA', label: 'TMUA (Test of Mathematics for University Admission)', format: 'test-score', min: 1, max: 9 },
          { value: 'ESAT', label: 'ESAT (Engineering and Science Admissions Test)', format: 'test-score', min: 0, max: 100 },
          { value: 'HAT', label: 'HAT (History Aptitude Test)', format: 'test-score', min: 0, max: 100 },
          { value: 'MLAT', label: 'MLAT (Modern Languages Admissions Test)', format: 'test-score', min: 0, max: 100 },
          { value: 'CAT', label: 'CAT (Classics Admissions Test)', format: 'test-score', min: 0, max: 100 },
        ],
      },
];